import { useModalStore } from '../../../store/ModalStore'
import GivewayHistoryModal from '../GivewayHistoryModal/GivewayHistoryModal'
import styles from './GivewayTopInfo.module.css'

const GivewayTopInfo = () => {

    const open = useModalStore((state) => state.open)
    const setOpen = useModalStore((state) => state.setOpen)

    return (
        <div className={styles.container}>
            <div className={styles.userInfoContainer}>
                <div className={styles.coinContainer}>
                    <div className={styles.ticketsText}>Мои билеты:</div>
                    <div className={styles.ticketsContainer__icon}>

                    </div>
                    <div className={styles.ticketsContainer__tickets}>
                        122
                    </div>
                </div>
            </div>
            <div onClick={() => setOpen('history')} className={styles.historyContainer}>
                <div className={styles.historyIcon}></div>
                <div className={styles.historyText}>
                    История
                </div>
            </div>
            {open === 'history' && <GivewayHistoryModal />}
        </div>
    )
}

export default GivewayTopInfo